import { customAlphabet } from 'nanoid'
import type { ColDefWithID } from '../contrains/ColumnTypes'
import { columnFactory, createDefaultColumns } from '../contrains/ColumnTypes'
import type { CellData, TableRowData } from '../types/data'
import { type LegacyTableMetadata, type TableMetadata, getColumnMetadata } from '../types/metadata'
import { rowFactory } from './rows'
import type { Elemental } from '~~/src/types/elemental'
import type { TableRowsAndColumnsResponse } from '~~/src/api/table'

export function generateSafeId() {
  return customAlphabet(
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
    9,
  )()
}

export function getInitialTableData() {
  const columns = [
    ...createDefaultColumns(['Name', 'Bio', 'Services']),
  ] as ColDefWithID[]
  const rowData = Array.from({ length: 3 }).map((_) => {
    const data = {
      ...rowFactory(),
    }

    for (const col of columns) {
      // @ts-expect-error variable is defined
      data[col.colId] = {
        template: '',
      }
    }

    return data
  }) as TableRowData[]

  return {
    columns,
    rowData,
  }
}

export function parseColumnsAndRowsFromData(
  data: TableRowsAndColumnsResponse,
  tableMetadata?: Elemental['metadata'],
) {
  const metadata = tableMetadata ?? ({} as TableMetadata | LegacyTableMetadata)

  const newColumns = data.columns.map((column) => {
    const field = `${column.field}` as string
    const columnMeta = getColumnMetadata(metadata, field)

    const columnData = {
      ...column,
      colId: field,
      field,
      editable: true,
      context: column,
      // Apply metadata configurations if they exist
      ...(columnMeta && {
        width: columnMeta.width,
        pinned: columnMeta.pinned,
        hide: !columnMeta.isVisible,
        sortIndex: columnMeta.index,
      }),
    }
    const newColumn = columnFactory('base', columnData)
    return newColumn
  })

  const newRows = data.rows.map((row) => {
    const newRow = {
      ...unref(row),
      id: row.field ?? randomID(),
    } as TableRowData
    return newRow
  })
  const columns = newColumns
  const rowData = newRows

  return {
    columns,
    rowData,
  }
}

export function getCellData(row: TableRowData | undefined, coldId?: string) {
  if (!row || !coldId)
    return null

  // @ts-expect-error - This is a valid property
  const data = row[coldId] as CellData | undefined

  if (!data)
    return null
  return data
}
